// Generated by purs version 0.13.8
"use strict";
var Control_Category = require("../Control.Category/index.js");
var Data_Argonaut_Core = require("../Data.Argonaut.Core/index.js");
var Data_Argonaut_Encode_Class = require("../Data.Argonaut.Encode.Class/index.js");
var Data_Argonaut_Types_Generic_Rep = require("../Data.Argonaut.Types.Generic.Rep/index.js");
var Data_Generic_Rep = require("../Data.Generic.Rep/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Foreign_Object = require("../Foreign.Object/index.js");
var Partial_Unsafe = require("../Partial.Unsafe/index.js");
var EncodeRepFields = function (encodeRepFields) {
    this.encodeRepFields = encodeRepFields;
};
var EncodeRepArgs = function (encodeRepArgs) {
    this.encodeRepArgs = encodeRepArgs;
};
var EncodeRep = function (encodeRepWith) {
    this.encodeRepWith = encodeRepWith;
};
var EncodeLiteral = function (encodeLiteral) {
    this.encodeLiteral = encodeLiteral;
};
var encodeRepWith = function (dict) {
    return dict.encodeRepWith;
};
var genericEncodeJsonWith = function (dictGeneric) {
    return function (dictEncodeRep) {
        return function (e) {
            var $53 = encodeRepWith(dictEncodeRep)(e);
            var $54 = Data_Generic_Rep.from(dictGeneric);
            return function ($55) {
                return $53($54($55));
            };
        };
    };
};
var genericEncodeJson = function (dictGeneric) {
    return function (dictEncodeRep) {
        return genericEncodeJsonWith(dictGeneric)(dictEncodeRep)(Data_Argonaut_Types_Generic_Rep.defaultEncoding);
    };
};
var encodeRepSum = function (dictEncodeRep) {
    return function (dictEncodeRep1) {
        return new EncodeRep(function (e) {
            return function (v) {
                if (v instanceof Data_Generic_Rep.Inl) {
                    return encodeRepWith(dictEncodeRep)(e)(v.value0);
                };
                if (v instanceof Data_Generic_Rep.Inr) {
                    return encodeRepWith(dictEncodeRep1)(e)(v.value0);
                };
                throw new Error("Failed pattern match at Data.Argonaut.Encode.Generic.Rep (line 37, column 1 - line 39, column 50): " + [ e.constructor.name, v.constructor.name ]);
            };
        });
    };
};
var encodeRepNoConstructors = new EncodeRep(function (e) {
    return encodeRepWith(encodeRepNoConstructors)(e);
});
var encodeRepFields = function (dict) {
    return dict.encodeRepFields;
};
var encodeRepFieldsProduct = function (dictEncodeRepFields) {
    return function (dictEncodeRepFields1) {
        return new EncodeRepFields(function (v) {
            return Foreign_Object.union(encodeRepFields(dictEncodeRepFields)(v.value0))(encodeRepFields(dictEncodeRepFields1)(v.value1));
        });
    };
};
var encodeRepArgsNoArguments = new EncodeRepArgs(function (v) {
    return [  ];
});
var encodeRepArgsArgument = function (dictEncodeJson) {
    return new EncodeRepArgs(function (v) {
        return [ Data_Argonaut_Encode_Class.encodeJson(dictEncodeJson)(v) ];
    });
};
var encodeRepArgs = function (dict) {
    return dict.encodeRepArgs;
};
var encodeRepArgsProduct = function (dictEncodeRepArgs) {
    return function (dictEncodeRepArgs1) {
        return new EncodeRepArgs(function (v) {
            return Data_Semigroup.append(Data_Semigroup.semigroupArray)(encodeRepArgs(dictEncodeRepArgs)(v.value0))(encodeRepArgs(dictEncodeRepArgs1)(v.value1));
        });
    };
};
var encodeRepConstructor = function (dictIsSymbol) {
    return function (dictEncodeRepArgs) {
        return new EncodeRep(function (e) {
            return function (v) {
                var values = (function () {
                    var vs = encodeRepArgs(dictEncodeRepArgs)(v);
                    if (e.unwrapSingleArguments) {
                        if (vs.length === 1) {
                            return vs[0];
                        };
                        return Data_Argonaut_Core.fromArray(vs);
                    };
                    return Data_Argonaut_Core.fromArray(vs);
                })();
                return Data_Argonaut_Core.fromObject(Foreign_Object.insert(e.tagKey)(Data_Argonaut_Core.fromString(Data_Symbol.reflectSymbol(dictIsSymbol)(Data_Symbol.SProxy.value)))(Foreign_Object.insert(e.valuesKey)(values)(Foreign_Object.empty)));
            };
        });
    };
};
var encodeRep = function (dictEncodeRep) {
    return encodeRepWith(dictEncodeRep)(Data_Argonaut_Types_Generic_Rep.defaultEncoding);
};
var encodeLiteralConstructorCannotBeProduct = function (dictFail) {
    return new EncodeLiteral(function (v) {
        return function (v1) {
            return Partial_Unsafe.unsafeCrashWith("unreachable encodeLiteral was reached.");
        };
    });
};
var encodeLiteralConstructor = function (dictIsSymbol) {
    return new EncodeLiteral(function (tagNameTransform) {
        return function (v) {
            return Data_Argonaut_Core.fromString(tagNameTransform(Data_Symbol.reflectSymbol(dictIsSymbol)(Data_Symbol.SProxy.value)));
        };
    });
};
var encodeLiteral = function (dict) {
    return dict.encodeLiteral;
};
var encodeLiteralSumInst = function (dictEncodeLiteral) {
    return function (dictEncodeLiteral1) {
        return new EncodeLiteral(function (tagNameTransform) {
            return function (v) {
                if (v instanceof Data_Generic_Rep.Inl) {
                    return encodeLiteral(dictEncodeLiteral)(tagNameTransform)(v.value0);
                };
                if (v instanceof Data_Generic_Rep.Inr) {
                    return encodeLiteral(dictEncodeLiteral1)(tagNameTransform)(v.value0);
                };
                throw new Error("Failed pattern match at Data.Argonaut.Encode.Generic.Rep (line 96, column 1 - line 98, column 80): " + [ tagNameTransform.constructor.name, v.constructor.name ]);
            };
        });
    };
};
var encodeLiteralSumWithTransform = function (dictGeneric) {
    return function (dictEncodeLiteral) {
        return function (tagNameTransform) {
            var $56 = encodeLiteral(dictEncodeLiteral)(tagNameTransform);
            var $57 = Data_Generic_Rep.from(dictGeneric);
            return function ($58) {
                return $56($57($58));
            };
        };
    };
};
var encodeLiteralSum = function (dictGeneric) {
    return function (dictEncodeLiteral) {
        return encodeLiteralSumWithTransform(dictGeneric)(dictEncodeLiteral)(Control_Category.identity(Control_Category.categoryFn));
    };
};
module.exports = {
    EncodeRep: EncodeRep,
    EncodeRepArgs: EncodeRepArgs,
    EncodeRepFields: EncodeRepFields,
    EncodeLiteral: EncodeLiteral,
    encodeRep: encodeRep,
    encodeRepWith: encodeRepWith,
    encodeRepArgs: encodeRepArgs,
    encodeRepFields: encodeRepFields,
    genericEncodeJson: genericEncodeJson,
    genericEncodeJsonWith: genericEncodeJsonWith,
    encodeLiteralSum: encodeLiteralSum,
    encodeLiteralSumWithTransform: encodeLiteralSumWithTransform,
    encodeLiteral: encodeLiteral,
    encodeRepNoConstructors: encodeRepNoConstructors,
    encodeRepSum: encodeRepSum,
    encodeRepConstructor: encodeRepConstructor,
    encodeRepArgsNoArguments: encodeRepArgsNoArguments,
    encodeRepArgsProduct: encodeRepArgsProduct,
    encodeRepArgsArgument: encodeRepArgsArgument,
    encodeRepFieldsProduct: encodeRepFieldsProduct,
    encodeLiteralSumInst: encodeLiteralSumInst,
    encodeLiteralConstructor: encodeLiteralConstructor,
    encodeLiteralConstructorCannotBeProduct: encodeLiteralConstructorCannotBeProduct
};
